// extracted by mini-css-extract-plugin
var _1 = "BuildingsField-modulebuildingsFieldTags__vkTVz FormFieldSelectNG-moduleformFieldMultiSelectTags__U0s9Y SelectValueTags-moduleSelectValueTags__hO7SX TagBar-moduleTagBar__a7w7V";
export { _1 as "buildingsFieldTags" }
